import clsx from 'clsx'
import React, {FC} from 'react'
import {useLayout} from '../../core'
import {DefaultTitle} from '../header/page-title/DefaultTitle'
import {KTSVG} from '../../../helpers'
import {useHistory} from 'react-router-dom'
import {GoBackBtn, localStorageKeyTemplateSelected} from '../../../../app/modules/all-pages'
import {UseWindowSize} from '../../../../app/modules/all-pages'
import {PropsWindowSize} from '../../../../app/modules/all-pages/Types'

const Toolbar1: FC = () => {

    const {classes} = useLayout();

  return (
    <div className='toolbar' id='kt_toolbar'>

      {/* begin::Container */}
      <div
        id='kt_toolbar_container'
        className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}
      >
        <DefaultTitle />

        {/* begin::Actions */}
        <div className='d-flex align-items-center py-1'>
          {/* begin::Wrapper */}
          <div className=''>

              <GoBackBtn />
            {/*/!* begin::go to back *!/*/}
            {/*  {*/}
            {/*      !pathname.includes("/dashboard")*/}
            {/*          ? (*/}
            {/*              <a href='#'*/}
            {/*                 className='btn btn-sm btn-flex bg-light-primary text-primary fw-bolder '*/}
            {/*                 onClick={handleClick}*/}

            {/*              >*/}
            {/*                  <KTSVG path='/media/icons/duotune/arrows/arr002.svg'*/}
            {/*                         className={`svg-icon-3 svg-icon-primary ${(windowSize.innerWidth >= 576) ? "me-2" : ""}`}*/}
            {/*                  />*/}
            {/*                  {(windowSize.innerWidth >= 576) ? "Retour" : ""}*/}
            {/*              </a>*/}
            {/*          ) : ""*/}
            {/*  }*/}

            {/*/!* end::go to back *!/*/}

            {/*/!* begin::Menu *!/*/}
            {/*<a*/}
            {/*  href='#'*/}
            {/*  className='btn btn-sm btn-flex btn-light btn-active-primary fw-bolder'*/}
            {/*  data-kt-menu-trigger='click'*/}
            {/*  data-kt-menu-placement='bottom-end'*/}
            {/*  data-kt-menu-flip='top-end'*/}
            {/*>*/}
            {/*  <KTSVG*/}
            {/*    path='/media/icons/duotune/general/gen031.svg'*/}
            {/*    className='svg-icon-5 svg-icon-gray-500 me-1'*/}
            {/*  />*/}
            {/*  こんにちは世界 👈🏽*/}
            {/*</a>*/}
            {/*/!* end::Menu *!/*/}
          </div>
          {/* end::Wrapper */}

          {/*/!* begin::Button *!/*/}
          {/*<a*/}
          {/*  href='#'*/}
          {/*  className='btn btn-sm btn-primary'*/}
          {/*  data-bs-toggle='components'*/}
          {/*  data-bs-target='#kt_modal_create_app'*/}
          {/*  id='kt_toolbar_primary_button'*/}
          {/*>*/}
          {/*  CrudId*/}
          {/*</a>*/}
          {/* end::Button */}
        </div>
        {/* end::Actions */}
      </div>
      {/* end::Container */}

    </div>
  )
}

export {Toolbar1}
